/**
 * 📅 [Phase 56.5 — 2026-07-09] Barre de navigation mensuelle du calendrier
 * de production. Extrait depuis CalendrierProduction.jsx (bloc ~L1535-1562).
 *
 * Contient : boutons ← / →, titre mois année, badge Organisation BT (Phase 51),
 * légende CCQ compacte (masquée sur mobile).
 *
 * Contrat :
 *   - `label` : ex. "Juillet 2026" (le parent gère la construction avec MOIS[])
 *   - `onPrev()` / `onNext()`
 *   - `orgBadge` : { date, refreshKey, onClick } passé au OrganisationBTBadge
 *
 * Aucun changement fonctionnel — pur split JSX.
 */
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { OrganisationBTBadge } from '@/components/organisation/OrganisationBTDialog';

export default function CalendarMonthNav({ label, onPrev, onNext, orgBadge }) {
  return (
    <div className="flex items-center justify-between px-4 py-2 bg-white border-b">
      <Button variant="ghost" size="sm" onClick={onPrev}>
        <ChevronLeft className="w-4 h-4" />
      </Button>
      <h2 className="text-xl font-bold flex items-center gap-3">
        {label}
        {/* 🆕 [Phase 51] Badge proactif rouge : N employés à organiser */}
        {orgBadge && (
          <OrganisationBTBadge
            date={orgBadge.date}
            refreshKey={orgBadge.refreshKey}
            onClick={orgBadge.onClick}
          />
        )}
      </h2>
      <div className="flex items-center gap-4">
        {/* Légende CCQ */}
        <div className="hidden sm:flex items-center gap-3 text-xs text-gray-500">
          <div className="flex items-center gap-1">
            <div className="w-4 h-3 bg-red-200 border border-red-300 rounded-sm" />
            <span>Jour férié CCQ</span>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-4 h-3 bg-yellow-200 border border-yellow-300 rounded-sm" />
            <span>Congé CCQ</span>
          </div>
        </div>
        <Button variant="ghost" size="sm" onClick={onNext}>
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
